module.exports = __webpack_public_path__ + "img/ic_problema.4cb5d0e9.svg";